module.exports = __webpack_public_path__ + "static/Horizon-cb49cd105a4fe5df19cd1b9ed58792a3.png";